/* eslint-disable no-console -- The logger mock uses `console.log` to log messages. */
import { mocked } from '@/configs';
import { Constructor } from '@/type-utils';
import type { ReturnsFlowStep } from '@/services/models/Returns/flow';
import MockService, { MockState, ServiceMock } from '../MockService';
import type { ReturnsLabelService } from './ReturnsLabelService';
import { LabelService } from './contracts/LabelService';

const initialState = {};

/**
 * Mock implementation of the LoggerService class.
 */
export default class ReturnsLabelServiceMock extends ServiceMock<ReturnsLabelService> {
  protected _state;

  /** @inheritdoc */
  public get state(): MockState {
    return this._state;
  }

  /** @inheritdoc */
  public getMock(): ReturnsLabelService {
    return MockService.getMockOf(
      this.service
    ) as unknown as ReturnsLabelService;
  }

  /**
   * The constructor to initialize the mocks.
   * @param service - The service that is being mocked.
   */
  public constructor(private service: Constructor<ReturnsLabelService>) {
    super();
    this._state = new MockState(initialState);
    this.initializeMockedMembers(service);
  }

  /** @inheritdoc */
  protected initializeMockedMembers(
    service: Constructor<ReturnsLabelService>
  ): void {
    const mockEnabled: boolean = mocked.ReturnsLabelService;

    MockService.mockService(
      mockEnabled,
      service,
      {
        getLabel: async () => {
          return {
            label: 'label',
            labelService: LabelService.UPS,
            reprintURL: 'http://localhost:3000',
            shipmentID: 'MOCK_SHIPMENT_ID',
            transactionID: 'MOCK_TRANSACTION_ID'
          };
        },
        getFlowStateFromSessionStorage: () => ({
          currentStep: 'confirmation' as ReturnsFlowStep,
          isOrderLoaded: true,
          haveItemsToReturnBeenSelected: true,
          isExchangeModeActive: false,
          isReturnTypeSelectionComplete: true,
          isReturnOrderComplete: true
        }),
        reprintLabel: async () => {
          return { label: 'label', isQRCode: true };
        },
        getLabelService: () => {
          return LabelService.UPS;
        }
      },
      {},
      this.state
    );
  }
}
